function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "bb5b6a91-2ee3-46f4-9043-0372c9c143a4",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5,47a45.16,45.16,0,0,1-4.15,7.76C52.65,58.83,48.83,64,44.13,64c-4.19,0-5.27-2.73-11-2.7S26.3,64,22.11,64c-4.75,0-8.3-4.67-11-8.78-7.56-11.49-8.34-25-3.68-32.15C10.7,18,15.92,15,20.84,15S29,17.73,33.11,17.73,39.56,15,45.34,15c4.37,0,9,2.37,12.29,6.52C46.83,27.4,48.58,42.83,59.5,47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,10.39A14.07,14.07,0,0,0,44.07,0a15.22,15.22,0,0,0-9.79,5.26c-2.12,2.59-3.88,6.41-3.19,10.15A12.88,12.88,0,0,0,41,10.39Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMac);
export default __webpack_public_path__ + "static/media/mac.392396e143c26616c694bccc4c23a8f7.svg";
export { ForwardRef as ReactComponent };